export default __webpack_public_path__ + "static/media/microgaming-logo.3a3d21f5.svg";